import React, {memo} from "react"
import {useHistory} from "react-router-dom"
import "./index.scss"
import { useChangeTheme } from "../../hooks/change-theme"

type Props = {
    icon?: string
    name?: string
    path?: string
}

export const SubMenuComponent = memo(function SubMenuComponent({icon, name, path}: Props) {
    const history = useHistory()
    const {theme} = useChangeTheme()
    return (
        <div className={`_custom-menu-box ${theme === 'rounded' ? '_custom-menu-options' : ''}`} onClick={() => history.push(path)}>
            <div className="_custom-menu-img">
                <img src={icon} alt="img" />
            </div>
            <span>{name}</span>
        </div>
    )
})
